import React from 'react';
import { ClipboardCheckIcon, FileTextIcon, GitForkIcon, MapIcon, Table2Icon } from 'lucide-react';
import { tools } from '../../data/landing';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
const icons = [FileTextIcon, ClipboardCheckIcon, GitForkIcon, Table2Icon, MapIcon];
export function Toolkit() {
  return <section className="w-full bg-navy px-5 py-16 md:py-24" data-id="element-293" data-mp="23bvajt6r65dl">
      <div className="mx-auto max-w-4xl" data-id="element-294" data-mp="27f1prqbuf6w7">
        <SectionHeading tone="dark" title="And you’ll also receive immediate access to:" data-id="element-295" data-mp="2cewfvrnsnsg7" />

        <ul className="mt-10 divide-y divide-white/10" data-id="element-296" data-mp="2ccjnslobo1pf">
          {tools.map((t, i) => {
          const Icon = icons[i];
          return <li key={t.title} className="flex items-start gap-4 py-6" data-id="element-297" data-mp="2m3o4bptnbumd" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-sky text-white" data-id="element-298" data-mp="2r4298yzyaog6">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-299" data-mp="2v4m601gm3q1s" />
                </span>
                <div data-id="element-300" data-mp="20x333kochbn9">
                  <h3 className="text-xl font-extrabold text-white" data-id="element-301" data-mp="20xbef84tk8wc">{t.title}</h3>
                  <p className="mt-1.5 text-[17px] leading-relaxed text-sky-light" data-id="element-302" data-mp="1vx77a8pswqis">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-8 max-w-xl text-center font-serif text-2xl font-bold leading-snug text-white" data-id="element-303" data-mp="1lzap4wyg4vb6">
          Any orthodontic case that enters your practice… you’ll have a structured place to start.
        </p>

        <div className="mt-10" data-id="element-304" data-mp="2enoll89vzjkm">
          <CtaButton tone="dark" label="I want access to the complete system" data-id="element-305" data-mp="2eoghkk7ebjbf" />
        </div>
      </div>
    </section>;
}